import { getGlobals, getBlogArchive, getBlogArchivePaths } from "storyblok/api"
import cache from "storyblok/cache"
import BlogArticlesSection from "components/Blog/BlogArticlesSection"
import Meta from "components/Meta"
import PageHeaderFull from "components/PageHeaderFull"

export default function BlogArchive({ blogArticles, number, meta, total, content }) {
  return (
    <>
      <Meta info={meta} />
      <PageHeaderFull {...content} />
      <BlogArticlesSection {...{ blogArticles, total, number }} />
    </>
  )
}

export async function getStaticProps({ params: { number = 1 } }) {
  const globals = await getGlobals()
  const page = await getBlogArchive()
  const { blogArticles, total } = cache.get(`blog/page/${number}`)

  return {
    props: {
      number,
      blogArticles,
      total,
      meta: page?.content?.twentysixty_seo ?? null,
      globals: globals ?? null,
      content: page.content ?? null,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getBlogArchivePaths(),
    fallback: false,
  }
}
